import { atom, useAtom } from 'jotai';

export const selectedFlagAtom = atom('');

export function useSelectedFlagAtom() {
  return useAtom(selectedFlagAtom);
}
